import { makeAutoObservable } from "mobx";
import {SwiperClass} from "swiper/react";
import {IXProduct} from "../models/Product";
import {StorageKeys} from "../utils/defaults";

export default class LoyaltyStoreX {

  storeList: IXProduct[] = []
  storeSubsList: IXProduct[] = []
  bestList: IXProduct[] = []
  bestListIx: number = 0
  bestListLoading: boolean = false

  totalSale: number = 40

  storiesTab: string = "inview"

  bonuses: number = 0
  bonusCard: any | null = null
  bonusHistory: any[] = []
  paysHistory: any[] = []
  chargedVisits: any[] = []

  isAccountLoaded: boolean = false

  visits: any[] = []

  loadingTimes: number = 1

  lastVisitDate: string = ""

  monthsStats: any | null = null

  isHelloVisible: boolean = false

  isPaySuccessVisible: boolean = false
  isPayFailVisible: boolean = false
  isBranchFindVisible: boolean = false
  isBranchFindStaffVisible: boolean = false
  isSupportVisible: boolean = false
  isNewSubsVisible: boolean = false
  isPromoVisible: boolean = false
  isRulesVisible: boolean = false
  isExcludedVisible: boolean = false
  isMAppVisible: boolean = false

  searchBranch: string = ""

  selectedOrder: any | null = null

  paySum: string = ""

  pageIndex: number = 0

  isLMVisible: boolean = true
  isSubMaxVisible: boolean = false
  isSubMinVisible: boolean = false

  selectedBranch: any | null = null
  selectedBranchStaff: any | null = null

  historySheatVisible: boolean = false

  wishesList: any[] = []
  myTickets: any[] = []
  selectedWish: any | null = null
  isWishesVisible: boolean = false
  isDeleteWish: boolean = false
  wishText: string = ""

  favorites: any[] = []

  myStatus: any = {id: 0, name: "start"}

  favsVisible: boolean = false

  refUser: any | null = null

  new_visits: any[] = []
  isNewVstsVisible: boolean = false

  isAccepted: boolean = false

  selectedProduct: any | null = null
  isProductVisible: boolean = false
  isOrdersVisible: boolean = false
  isReferalVisible: boolean = false
  isTourneyVisible: boolean = false
  isWalletsVisible: boolean = false
  isSubscribeVisible: boolean = false
  isAccountVisible: boolean = false
  isHistoryVisible: boolean = false
  isBonusHistoryVisible: boolean = false
  isStatusesVisible: boolean = false
  isStatusesInfoVisible: boolean = false
  isReferalsListVisible: boolean = false
  isFriendsBonusVisible: boolean = false

  selectedStatus: any | null = null

  mainVisible: boolean = false

  absPhoto: string = ""
  absBranch: string = ""
  absBranchStaff: string = ""

  selectedNextSub: string = ""
  swiperIndex: number = 0

  wallets: any[] = []
  activeWallet: any | undefined = undefined

  isTSPrePreVisible: boolean = false
  isTSPreVisible: boolean = false
  isTSVisible: boolean = false

  isTSXPrePreVisible: boolean = false
  isTSXPreVisible: boolean = false
  isTSXVisible: boolean = false

  isSPrePreVisible: boolean = false
  isSPreVisible: boolean = false
  isSVisible: boolean = false

  isSXPrePreVisible: boolean = false
  isSXPreVisible: boolean = false
  isSXVisible: boolean = false

  isSXDPrePreVisible: boolean = false
  isSXDPreVisible: boolean = false
  isSXDVisible: boolean = false

  isSXXPrePreVisible: boolean = false
  isSXXPreVisible: boolean = false
  isSXXVisible: boolean = false

  isSXAPrePreVisible: boolean = false
  isSXAPreVisible: boolean = false
  isSXAVisible: boolean = false

  isBrillLinesVisible: boolean = false

  gradStatus: string = "grad_bronze"
 
  swiper: null | SwiperClass = null as SwiperClass | null
  swiperA: null | SwiperClass = null as SwiperClass | null

  constructor() {
    makeAutoObservable(this)
  }

  setIsBrillLinesVisible(val: boolean) {
    this.isBrillLinesVisible = val
  }

  setSwiperIndex(val: number) {
    this.swiperIndex = val
  }

  setSwiper(val: any) {
    this.swiper = val
  }

  setSwiperA(val: any) {
    this.swiperA = val
  }

  setGradStatus(st: string) {
    this.gradStatus = st
  }

  openTicketShop() {
    this.isTSPrePreVisible = true
    setTimeout(() => {
      this.isTSPreVisible = true
      setTimeout(() => {
        this.isTSVisible = true
      }, 300)
    }, 100)
  }

  closeTicketShop() {
    this.isTSVisible = false
    setTimeout(() => {
      this.isTSPreVisible = false
      setTimeout(() => {
        this.isTSPrePreVisible = false
      }, 300)
    }, 300)
  }

  openAdjuster() {
    this.isSXAPrePreVisible = true
    setTimeout(() => {
      this.isSXAPreVisible = true
      setTimeout(() => {
        this.isSXAVisible = true
      }, 300)
    }, 100)
  }

  closeAdjuster() {
    this.isSXAVisible = false
    setTimeout(() => {
      this.isSXAPreVisible = false
      setTimeout(() => {
        this.isSXAPrePreVisible = false
      }, 300)
    }, 300)
  }

  openStatusDiamond() {
    this.isSXDPrePreVisible = true
    setTimeout(() => {
      this.isSXDPreVisible = true
      setTimeout(() => {
        this.isSXDVisible = true
      }, 300)
    }, 100)
  }

  closeStatusDiamond() {
    this.isSXDVisible = false
    setTimeout(() => {
      this.isSXDPreVisible = false
      setTimeout(() => {
        this.isSXDPrePreVisible = false
      }, 300)
    }, 300)
  }

  openStatusesPrizes() {
    this.isSXPrePreVisible = true
    setTimeout(() => {
      this.isSXPreVisible = true
      setTimeout(() => {
        this.isSXVisible = true
      }, 300)
    }, 100)
  }

  closeStatusesPrizes() {
    this.isSXVisible = false
    setTimeout(() => {
      this.isSXPreVisible = false
      setTimeout(() => {
        this.isSXPrePreVisible = false
      }, 300)
    }, 300)
  }

  openComps() {
    this.isSXXPrePreVisible = true
    setTimeout(() => {
      this.isSXXPreVisible = true
      setTimeout(() => {
        this.isSXXVisible = true
      }, 300)
    }, 100)
  }

  closeComps() {
    this.isSXXVisible = false
    setTimeout(() => {
      this.isSXXPreVisible = false
      setTimeout(() => {
        this.isSXXPrePreVisible = false
      }, 300)
    }, 300)
  }

  openStatuses() {
    this.isSPrePreVisible = true
    setTimeout(() => {
      this.isSPreVisible = true
      setTimeout(() => {
        this.isSVisible = true
      }, 300)
    }, 100)
  }

  closeStatuses() {
    this.isSVisible = false
    setTimeout(() => {
      this.isSPreVisible = false
      setTimeout(() => {
        this.isSPrePreVisible = false
      }, 300)
    }, 300)
  }

  openTickets() {
    this.isTSXPrePreVisible = true
    setTimeout(() => {
      this.isTSXPreVisible = true
      setTimeout(() => {
        this.isTSXVisible = true
      }, 300)
    }, 100)
  }

  closeTickets() {
    this.isTSXVisible = false
    setTimeout(() => {
      this.isTSXPreVisible = false
      setTimeout(() => {
        this.isTSXPrePreVisible = false
      }, 300)
    }, 300)
  }

  setSelectedStatus(val: any) {
    this.selectedStatus = val
  }

  setActiveWallet(val: any | undefined) {
    this.activeWallet = val
  }

  setWallets(val: any[]) {
    this.wallets = val
  }

  setIsWalletsVisible(val: boolean) {
    this.isWalletsVisible = val
  }

  setIsTourneyVisible(val: boolean) {
    this.isTourneyVisible = val
  }

  setSelectedNextSub(sub: string) {
     this.selectedNextSub = sub
  }

  setAbsPhoto(val: string) {
    this.absPhoto = val
  }

  setAbsBranchStaff(val: string) {
    this.absBranchStaff = val
  }

  setAbsBranch(val: string) {
    this.absBranch = val
  }

  setMainVisible(val: boolean) {
    this.mainVisible = val
  }

  setIsBonusHistoryVisible(val: boolean) {
    this.isBonusHistoryVisible = val
  }

  setIsStatusesVisible(val: boolean) {
    this.isStatusesVisible = val
  }

  setIsFriendsBonusVisible(val: boolean) {
    this.isFriendsBonusVisible = val
  }

  setIsReferalsListVisible(val: boolean) {
    this.isReferalsListVisible = val
  }

  setIsStatusesInfoVisible(val: boolean) {
    this.isStatusesInfoVisible = val
  }

  setIsHistoryVisible(val: boolean) {
    this.isHistoryVisible = val
  }

  setIsAccountVisible(val: boolean) {
    this.isAccountVisible = val
  }

  setIsOrdersVisible(val: boolean) {
    this.isOrdersVisible = val
  }

  setIsReferalVisible(val: boolean) {
    this.isReferalVisible = val
  }

  setIsSubscribeVisible(val: boolean) {
    this.isSubscribeVisible = val
  }

  setIsProductVisible(val: boolean) {
    this.isProductVisible = val
  }

  setSelectedProduct(val: any) {
    this.selectedProduct = val
  }

  setIsAccepted(value: boolean) {
    this.isAccepted = value
  }

  setNewVisits(val: any) {
    this.new_visits = val
  }

  setIsNewVstsVisible(val: boolean) {
    this.isNewVstsVisible = val
  }

  setRefUser(user: any) {
    this.refUser = user
  }

  setFavsVisible(val: boolean) {
    this.favsVisible = val
  }

  setFavs(val: any) {
    this.favorites = val
  }

  setMyStatus(val: any) {
    this.myStatus = val
  }

  setWishText(val: string) {
    this.wishText = val
  }

  setWishesList(val: any[]) {
    this.wishesList = val
  }

  setMyTickets(val: any[]) {
    this.myTickets = val
  }

  setSelectedWish(val: any) {
    this.selectedWish = val
  }

  setIsWishesVisible(val: boolean) {
    this.isWishesVisible = val
  }

  setIsDeleteWish(val: boolean) {
    this.isDeleteWish = val
  }

  setHistorySheatVisible(val: boolean) {
    this.historySheatVisible = val
  }

  setSelectedBranch(branch: any) {
    this.selectedBranch = branch
  }

  setSelectedBranchStaff(branch: any) {
    this.selectedBranchStaff = branch
  }

  setIsExcludedVisible(val: boolean) {
    this.isExcludedVisible = val
  }

  setIsMAppVisible(val: boolean) {
    this.isMAppVisible = val
  }

  setIsRulesVisible(val: boolean) {
    this.isRulesVisible = val
  }

  setIsSubMaxVisible(val: boolean) {
    this.isSubMaxVisible = val
  }

  setIsSubMinVisible(val: boolean) {
    this.isSubMinVisible = val
  }

  setIsHelloVisible(val: boolean) {
    this.isHelloVisible = val
  }

  setIsLMVisible(val: boolean) {
    this.isLMVisible = val
  }

  setPageIndex(val: number) {
    this.pageIndex = val
  }

  setPaySum(val: string) {
    this.paySum = val
  }

  setIsPromoVisible(val: boolean) {
    this.isPromoVisible = val
  }

  setIsNewSubsVisible(val: boolean) {
    this.isNewSubsVisible = val
  }

  setIsSupportVisible(val: boolean) {
    this.isSupportVisible = val
  }

  setSelectedOrder(val: any) {
    this.selectedOrder = val
  }
 
  setSearchBranch(val: string) {
    this.searchBranch = val
  }

  setIsBranchFindStaffVisible(val: boolean) {
    this.isBranchFindStaffVisible = val
  }

  setIsBranchFindVisible(val: boolean) {
    this.isBranchFindVisible = val
  }

  setIsPaySuccessVisible(val: boolean) {
    this.isPaySuccessVisible = val
  }
  
  setIsPayFailVisible(val: boolean) {
    this.isPayFailVisible = val
  }

  setMonthsStats(val: any) {
    this.monthsStats = val
    localStorage.setItem(StorageKeys.MONTH_STATS, JSON.stringify(val))
  }

  setLastVisitDate(val: string) {
    this.lastVisitDate = val
  }

  setLoadingTimes(times: number) {
    this.loadingTimes = times
  }

  setVisits(val: any[]) {
    this.visits = val
  }

  setIsAccountLoaded(val: boolean) {
    this.isAccountLoaded = val
  }

  setBonusCard(val: any) {
    this.bonusCard = val
  }

  setBonuses(val: number) {
    this.bonuses = val
  }

  setBonusHistory(val: any[]) {
    this.bonusHistory = val
  }

  setPaysHistory(val: any[]) {
    this.paysHistory = val
  }

  setChargedVisits(val: any[]) {
    this.chargedVisits = val
  }

  setStoriesTab(val: string) {
    this.storiesTab = val
  }

  setStoreList(val: IXProduct[]) {
    this.storeList = val
  }

  setStoreSubsList(val: IXProduct[]) {
    this.storeSubsList = val
  }

  setBestList(val: IXProduct[]) {
    this.bestList = val
  }

  setBestListIx(val: number) {
    this.bestListIx = val
  }

  setBestListLoading(val: boolean) {
    this.bestListLoading = val
  }

}